import React from "react";

import "./ChartIcons.scss";

const SinglePlot = props => {
  const getClassName = () => {
    const styleClass = "chart-icon";
    return props.active && !props.disabled ? `${styleClass}-active` : styleClass;
  };
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className={getClassName()} disabled={props.disabled}>
        <g id="Single_Chart" data-name="Single Chart" transform="translate(0.5 0.5)">
          <g id="Group_15141" data-name="Group 15141">
            <path id="margin" fill="#fff" stroke="#707070" opacity="0" d="M0 0H32V32H0Z" />
            <path
              id="Path_12999"
              data-name="Path 12999"
              className="icon-fill"
              d="M20.5 12.4l1.336 1.336-2.847 2.847-2.333-2.334-4.323 4.329.823.822 3.5-3.5 2.333 2.333 3.675-3.669L24 15.9V12.4Z"
            />
            <line
              id="Line_308"
              data-name="Line 308"
              fill="none"
              className="icon-stroke"
              strokeLinecap="square"
              strokeMiterlimit="10"
              y2="16"
              transform="translate(8 7.9)"
            />
            <line
              id="Line_309"
              data-name="Line 309"
              fill="none"
              className="icon-stroke"
              strokeLinecap="square"
              strokeMiterlimit="10"
              x1="16"
              transform="translate(8 24)"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default SinglePlot;
